import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PaypalExpressButtonComponentDef } from '@df/module-paypal/paypal-express-button.component.def';
import { ResultComponent } from '../../ui/api/result.component';

@Component({
    selector: 'paypal-express-button',
    template: `<div id="paypal-express-button"></div>
        <div *ngIf="status.busy" class="w-12 center">
            <i class="icon-loading"></i>
        </div>
        <result [status]="status"></result> `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ResultComponent, CommonModule]
})
export class PaypalExpressButtonComponent extends PaypalExpressButtonComponentDef {}
